var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.title.length)?_c('tr',{staticClass:"group"},[_c('td',{staticClass:"group__title"},[_c('span',[_vm._v(_vm._s(_vm.title))])]),_c('td'),_c('td'),_c('td'),_c('td'),_c('td'),_c('td'),_c('td'),_c('td')]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }